export default __webpack_public_path__ + "static/media/searchIconBlack.5e0abd20.svg";